import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ModalController, ToastController } from "@ionic/angular";
import { BoardResponse } from "src/app/model/BoardResponse";
import { ApplicantStatusService } from "src/app/services/Applicant-Status.service";

@Component({
  selector: "forward-another-authority-case",
  templateUrl: "./forward-another-authority-case.component.html",
})
export class ForwardAnotherAuthorityComponent implements OnInit {
  forwardForm: FormGroup;
  appointmentId: number;
  addresses: string[] = [];
  selectedAddresses: string[] = [];
  typedAddress: string = '';
  selectedAddress: string = '';
  officerList: any[];
  authoritys: any[] = [];
  selectedauthority: string[] = [];
  boardResponse: BoardResponse;
  boards: string[] = [];
  selectedOfficerKey: any;
  appointmentSlots: any[] = [];
  selectedSlotKey: any; // Add this line to store the selected slot key

  constructor(
    private modalCtrl: ModalController,
    private toastController: ToastController,
    private applicantStatusService: ApplicantStatusService
  ) {}

  ngOnInit(): void {
    this.forwardForm = new FormGroup({
      forwardReason: new FormControl(null, [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(2000),
      ]),
    });

    // Fetch addresses based on appointment ID
    this.fetchAddresses();
    this.getBoard();
    this.fetchAuthorityList();
  }

  onOfficerChange(selectedValue: any) {
    this.selectedOfficerKey = selectedValue;
    this.findOpenSlots(selectedValue); // Call the function to pass the user key
  }

  async findOpenSlots(selectedValue) {
    try {
      this.selectedOfficerKey = selectedValue;
      console.log("Selected Officer Key:", this.selectedOfficerKey);

      this.applicantStatusService
        .findOpenSlots(this.selectedOfficerKey)
        .subscribe((data: any) => {
          console.log("findOpenSlots", data);
          this.appointmentSlots = data;
        });
    } catch (error) {
      console.error("Error fetching appointment slots:", error);
    }
  }

  onSlotSelect(slotKey: any) {
    this.selectedSlotKey = slotKey;
    console.log("Selected Slot Key:", this.selectedSlotKey);
  }

  async fetchAddresses() {
    try {
      console.log("Fetching addresses for appointment ID:", this.appointmentId);

      this.applicantStatusService
        .findAddress()
        .subscribe((data: any) => {
          console.log("Fetched addresses:", data);
          this.addresses = data.map((item: any) => item.address);
        });
    } catch (error) {
      console.error("Error fetching addresses:", error);
    }
  }

  toggleAddressSelection(address: string) {
    if (this.isSelected(address)) {
      this.selectedAddresses = this.selectedAddresses.filter(
        (selectedAddress) => selectedAddress !== address
      );
    } else {
      this.selectedAddresses = [address];
    }
  }

  isSelected(address: string): boolean {
    return this.selectedAddresses.includes(address);
  }

  async showErrorToast(errorMessage: string) {
    const toast = await this.toastController.create({
      message: errorMessage,
      icon: "information-circle",
      position: "top",
      duration: 2000,
    });
    toast.present();
  }

  forward() {
    console.log("Forwarding with reason:", this.forwardForm.value.forwardReason);
    console.log("Selected Officer Key:", this.selectedOfficerKey);
    console.log("Selected Slot Key:", this.selectedSlotKey);

    
    if (!this.selectedOfficerKey) {
      this.showErrorToast("Please select a Officer For Forward Appointment");
      return;
    }
    if (!this.selectedSlotKey) {
      this.showErrorToast("Please select a slot");
      return;
    }
    if (!this.forwardForm.value.forwardReason) {
      this.showErrorToast("Please enter a forward reason");
      return;
    }
    
    if (this.forwardForm.valid) {
      return this.modalCtrl.dismiss(
        {
          forwardReason: this.forwardForm.value.forwardReason,
          selectedOfficerKey: this.selectedOfficerKey,
          selectedSlotKey: this.selectedSlotKey // Include the selected slot key
        },
        "forward"
      );
    }
  }

  cancel() {
    return this.modalCtrl.dismiss(null, "cancel");
  }

  handleKeyPress(event: KeyboardEvent): void {
    const textarea = event.target as HTMLTextAreaElement;
    const cursorPosition = textarea.selectionStart;
    if (cursorPosition === 0 && event.key === " ") {
      event.preventDefault();
    }
  }

  async fetchAuthorityList() {
    try {
      console.log("Fetching authority list");

      this.applicantStatusService
        .fetchAuthorityListInit()
        .subscribe((data: any) => {
          console.log("Fetched authority list:", data);
          this.authoritys = data;
        });
    } catch (error) {
      console.error("Error fetching authority list:", error);
    }
  }

  getBoard() {
    this.applicantStatusService.fetchBoardList().subscribe((data: any) => {
      console.log("Fetched board list:", data);
      this.boards = data.map((item: any) => item.board);
    });
  }
}


